angular.module("inputEmail.components", []).component("inputEmail", {
  templateUrl: "ng/components/inputEmail/inputEmail.html",
  bindings: {
    /** Input data **/
    inputId: "@",
    inputName: "@",
    inputClass: "@",
    formName: "=",
    bindingVariable: "=",
    setInvalid: "<",
    /** Optional data **/
    checkUnique: "<",
    listaPf: "<",
    pfIdentifier: "@",
    inputDisableOn: "<",
    errorMsg: "@",
    autoInvalid: "@",
    uniquenessOnBlur: "<",
    onChange: "&?",
    isLo: "=",
    maxLength: "<"
  },
  controllerAs: "inputEmailCtrl",
  controller: function (
    validationService,
    verifyUniqueService,
    $searchUserService
  ) {
    /** not to loose *this reference **/
    var self = this;

    self.validationService = validationService;
    self.model = {};
    self.errorMsgShown = false;

    if (!self.setInvalid) {
      self.setInvalid = false;
    }

    self.verifyUniqueService = verifyUniqueService;
    //self.inputHasError = false;

    //self.inputError = false;

    self.$onInit = function () {
      self.inputDisableOn = self.inputDisableOn || false;
      self.autoInvalid = !!self.autoInvalid;
      self.uniquenessOnBlur = !!self.uniquenessOnBlur;
      $('[data-toggle="tooltip"]').tooltip();
      self.formName &&
        self.formName[self.inputName] &&
        self.formName[self.inputName].$setValidity("email", true);

      self.model = {
        cdDestinatarioFatturazione: "",
        emailFatturazioneElettronica: "",
        riferimentoAmministrativo: "",
      };
    };

    self.onBlur = function (email) {
      if (!self.uniquenessOnBlur) return;

      /** Validate email */
      if (
        !self.bindingVariable ||
        self.bindingVariable == "" ||
        !self.validationService.isValidEmail(self.bindingVariable)
      ) {
        self.inputError = true;
        return;
      }


      /** Only if it is a valid email call service for it to be unique */
      $searchUserService
        .isCustomerMailUnique(self.bindingVariable, self.pfIdentifier)
        .then(function (unique) {
          /** Here exlamative icon triggers! */
          if (!self.verifyAppUniqueItemResult)
            self.unique = !!unique;

        });

    };

    self.change = function (email) {
      //self.inputError = false;

      if (typeof email == "undefined") {
        self.formName &&
          self.formName[self.inputName] &&
          self.formName[self.inputName].$setValidity("email", false);
        self.inputError = true;
        return;
      }

      if (email == "") {
        if (self.inputRequired) {
          self.formName &&
            self.formName[self.inputName].$setValidity("email", false);
          self.inputError = true;
        } else {
          self.formName &&
            self.formName[self.inputName].$setValidity("email", true);
          self.inputError = false;
        }
        return;
      }

      if (email && !validationService.isValidEmail(email)) {
        self.formName &&
          self.formName[self.inputName] &&
          self.formName[self.inputName].$setValidity("email", false);
        self.inputError = true;

        if (typeof self.onChange === "function") {
          self.onChange({
            value: email,
          });
        }

        return;
      }

      self.onBlurFunction();

      //here the field is valid, return false before this point if you got here
      self.formName &&
        self.formName[self.inputName] &&
        self.formName[self.inputName].$setValidity("email", true);
      self.inputError = false;
      self.model.emailFatturazioneElettronica = email;
      self.valid = true;

      if (typeof self.onChange === "function") {
        self.onChange({
          value: email,
        });
      }
    };

    self.onBlurFunction = function () {
      if (
        self.bindingVariable &&
        self.bindingVariable.length &&
        !validationService.isValidEmail(self.bindingVariable)
      ) {
        $("#" + self.inputId).addClass("has-error");
        self.inputHasError = true;
      } else {
        $("#" + self.inputId).removeClass("has-error");
        self.inputHasError = false;
      }

      if (self.checkUnique && self.bindingVariable != "") {
        if (self.listaPf) {
          var isUnique = !self.listaPf.some(function (pf) {
            return (
              pf.cf != self.pfIdentifier && pf.email == self.bindingVariable
            );
          });
          if (isUnique) {
            callVerifyService();
          } else {
            self.formName[self.inputName].$setValidity("unique", false);
          }
        } else {
          callVerifyService();
        }

        function callVerifyService() {
          self.verifyUniqueService
       /*      .verifyAppUniqueItem({
              identifier: self.pfIdentifier,
              email: self.bindingVariable,
            }) */
            $searchUserService
            .isCustomerMailUnique(self.bindingVariable, self.pfIdentifier)
            .then(function (response) {
              if (response.success) {
                if (response.unique) {
                  self.formName[self.inputName].$setValidity("unique", true);
                } else {
                  self.verifyAppUniqueItemResult = false;
                  self.formName[self.inputName].$setValidity("unique", false);
                }
                self.formName[self.inputName].$invalid = !response.unique;
                self.formName[self.inputName].$valid = response.unique;
              }
            });
        }
      }
    };

    self.$onChanges = function () { };

    self.resetAlert = function () {
      self.errorMsgShown = false;
    };

    self.showAlertMsg = function () {
      self.errorMsgShown = !self.errorMsgShown;
    };

    self.isInvalid = function () {
      if (self.formName && self.formName[self.inputName]) {
        self.inputHasError =
          (!self.formName[self.inputName].$pristine && self.setInvalid) ||
          (!self.formName[self.inputName].$pristine &&
            (self.formName[self.inputName].$error.pattern ||
              self.formName[self.inputName].$error.required));
      }
    };
  },
});
